// frontend_app/src/lib/format.js

const DAY = 86400;

/** "3 May 2026" from a unix timestamp (seconds). */
export const formatDate = (timestamp) => {
  if (!timestamp) return '—';
  return new Date(timestamp * 1000).toLocaleDateString('en-AU', {
    day: 'numeric', month: 'short', year: 'numeric',
  });
};

export const formatDateTime = (timestamp) => {
  if (!timestamp) return '—';
  return new Date(timestamp * 1000).toLocaleString('en-AU', {
    day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit',
  });
};

/** "just now", "5 min ago", "3 days ago", "4 months ago". */
export const formatRelative = (timestamp, now = Date.now() / 1000) => {
  if (!timestamp) return 'never';
  const diff = Math.max(0, now - timestamp);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < DAY) {
    const hours = Math.floor(diff / 3600);
    return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  }
  const days = Math.floor(diff / DAY);
  if (days < 60) return `${days} day${days === 1 ? '' : 's'} ago`;
  const months = Math.floor(days / 30);
  if (months < 24) return `${months} months ago`;
  return `${Math.floor(days / 365)} years ago`;
};

export const daysSince = (timestamp, now = Date.now() / 1000) =>
  timestamp ? Math.floor((now - timestamp) / DAY) : null;

/** "2m 05s" for a duration in seconds. */
export const formatDuration = (seconds) => {
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${String(s % 60).padStart(2, '0')}s`;
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}m`;
};
